/** default attribute name which use for geometry info */
export const GEOMETRY_ATTRIBUTE = "geometry";

/** default attribute name which contains unique id info */
export const DEFAULT_ID_ATTRIBUTE_NAME = "gid";

/** default attribute name which use for polygon calculated area info */
export const AREA_ATTRIBUTE = "area";

/** default attribute name which use for calculated line info */
export const LINE_ATTRIBUTE = "length";

/** default attribute name which use for calculated centroid info */
export const CENTROID_ATTRIBUTE = "coordinates";

/** default attribute name which use for attribute name */
export const NAME_ATTRIBUTE = "name";

/** default attribute name which use for attribute name */
export const DATE_OF_IMAGE_ATTRIBUTE = "dateofimage";

/** default attribute name which use for attribute name */
export const STATUS_ATTRIBUTE = "status";
